import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import RatesUtility from '@sparta.sales.utilities/rates-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row alert\">\r\n    <h2>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"header") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n    <p>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n</div>\r\n\r\n\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/page-error-auto-module",
  "version": "1.0.2",
  "id": "pageErrorAutoModule",
  "containerID": "autoLoansPageErrorAutoModule",
  "moduleName": "auto-loans-page-error-auto-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "page-error-auto-module",
  "data": {
    "init": "pageErrorAutoModuleJS"
  },
  "moduleParams": [{
    "name": "modulesToHide",
    "type": "array",
    "default": null,
    "description": "pass Element selectors as values(Eg: ['#moduleIdName', '.moduleclassName','#elementIdName','.elementClassName']) to this parameter to hide the elements when rates calls fails"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.sales.utilities/rates-utility": "^1.0.0"
  },
  "stores": []
};

/*
 * page-error-auto-module
 * module_js_id: pageErrorAutoModuleJS
 *
 * Copyright (c) 2016-7-25 Bank of America
 */

/**
 * @class pageErrorAutoModuleJS
 * @extends {Module}
 */
class pageErrorAutoModuleJS extends Module {
  /**
   * Creates an instance of pageErrorAutoModuleJS.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof pageErrorAutoModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $(options.target);
  }

  /**
   *
   * Runs on module init
   * @returns {undefined}
   */
  init() {
    const {
      modulesToHide
    } = this.$target.data('module-parameters');
    const target = this.$target;
    if (modulesToHide && modulesToHide.length > 0) {
      RatesUtility.getAutoLoans(this.Store.getUserSelectedState(), false).then(() => {
        target.hide();
      }).fail(() => {
        target.find('#err_return_to_your_accounts').hide();
        target.show();
        $(modulesToHide.join(',')).remove();
      });
    }
  }
}
registerModuleClass({
  moduleClass: pageErrorAutoModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { pageErrorAutoModuleJS as default, moduleConfig };
